import { observer } from 'mobx-react-lite';
import { Grid } from 'semantic-ui-react';
import { store, useStore } from '../../../app/stores/store';
import DashboardAssetTable from './DashboardAssetTable';
import ChartData from '../Charts/ChartData';
import DashboardGridDelivery from './DashboardGridDelivery';
import DashboardGridOrders from './DashboardGridOrders';
import DashboardGridReceiving from './DashboardGridReceiving';
import InventoryReports from './InventoryReports';
import Outwardstable from '../Orders/Outwards/Outwardstable';
import InwardsTable from '../Orders/Inwards/InwardsTable';
import DeliveryRequest from './deliveryRequest';
import NFAIRestorationDashboard from '../../NFAIRestorationDashboard';

function DashboardShowGrid() {
  const {
    dashboardStore,
    RolesAndPermissionsIDStore,
    userStore: { user },
    commonStore: { NFAIReportCustomer }
  } = useStore();

  const filterRolesHandler = (id: string) => {
    let result = RolesAndPermissionsIDStore.rolesIDs?.filter((data) => {
      return data.itemId === id;
    });
    return !!result?.length;
  };

  return (
    <div className="dashboard-L2-L3">
      {dashboardStore.dashboard.L2CardValueInventory === 'Receiving' &&
        dashboardStore.dashboard.valueForL3Inventory !== '' && (
          <DashboardGridReceiving />
        )}
      {dashboardStore.dashboard.L2CardValueInventory === 'Delivery' && (
        // dashboardStore.dashboard.valueForL3Inventory !== "" &&
        <DashboardGridDelivery />
      )}

      {dashboardStore.dashboard.L2CardValueInventory === 'Reports' &&
        dashboardStore.dashboard.valueForL3Inventory !== '' && (
          <Grid stackable>
            <Grid.Row>
              <ChartData />
            </Grid.Row>
            <Grid.Row>
              <InventoryReports />
            </Grid.Row>
          </Grid>
        )}
      {/* to show report when top layer clicked this has nothing to do with data  */}
      {dashboardStore.dashboard.L1CardValue === 'Orders' &&
        dashboardStore.dashboard.L2CardValueOrders !== '' &&
        dashboardStore.dashboard.valueForL3Orders !== '' && (
          <DashboardGridOrders />
        )}
      {/* to show report when top layer clicked this has nothing to do with data  */}
      {dashboardStore.dashboard.L1CardValue !== '' &&
        dashboardStore.dashboard.L1CardValue !== 'Orders' &&
        dashboardStore.dashboard.L1CardValue !== 'Production' &&
        dashboardStore.dashboard.L2CardValueInventory === '' &&
        dashboardStore.dashboard.L2CardValueOrders === '' &&
        dashboardStore.dashboard.L2CardValuePlanning === '' && (
          <Grid stackable>
            {(user?.customerName !== 'NFAI' ||
              window.innerWidth > 1025 ||
              window.innerWidth < 1020) && (
              <Grid.Row>
                {NFAIReportCustomer ? <></> : <ChartData />}
              </Grid.Row>
            )}
            <Grid.Row>
              {NFAIReportCustomer ? <NFAIRestorationDashboard /> : 
              <DashboardAssetTable />
            }
            </Grid.Row>
          </Grid>
        )}
      {/* to show report when top layer clicked this has nothing to do with data  */}
      {dashboardStore.dashboard.L1CardValue === '' && (
        <Grid stackable>
          <Grid.Row>
            <></>
          </Grid.Row>
          <Grid.Row
            className={`dashboardAssetTableRow ${
              !filterRolesHandler('DL1B1') &&
              'dashboardAssetTableRow-isDisabled'
            }`}
          >
            <></>
          </Grid.Row>
        </Grid>
      )}
      {/* to show report when top layer clicked this has nothing to do with data  */}
      {dashboardStore.dashboard.L1CardValue === 'Inventory' &&
        dashboardStore.dashboard.L2CardValueInventory !== '' &&
        dashboardStore.dashboard.L2CardValueInventory !== 'Delivery' &&
        dashboardStore.dashboard.valueForL3Inventory === '' && (
          <Grid stackable>
            <Grid.Row>
              <ChartData />
            </Grid.Row>
            <Grid.Row>
              {NFAIReportCustomer ? <NFAIRestorationDashboard /> : <DashboardAssetTable />}
            </Grid.Row>
          </Grid>
        )}
      {/* to show report when top layer clicked this has nothing to do with data  */}
      {dashboardStore.dashboard.L1CardValue === 'Orders' &&
        dashboardStore.dashboard.L2CardValueOrders === 'Outward' &&
        dashboardStore.dashboard.valueForL3Orders === '' && (
          <Grid stackable>
            <Grid.Row>
              <ChartData />
            </Grid.Row>
            <Grid.Row>
              <Outwardstable name="TagOrder" />
            </Grid.Row>
          </Grid>
        )}

      {dashboardStore.dashboard.L1CardValue === 'Orders' &&
        dashboardStore.dashboard.L2CardValueOrders === 'Inward' &&
        dashboardStore.dashboard.valueForL3Orders === '' && (
          <Grid stackable>
            <Grid.Row>
              <ChartData />
            </Grid.Row>
            <Grid.Row>
              <InwardsTable name="Verify" />
            </Grid.Row>
          </Grid>
        )}
      {dashboardStore.dashboard.L1CardValue === 'Orders' &&
        dashboardStore.dashboard.L2CardValueOrders === 'Reports' &&
        dashboardStore.dashboard.valueForL3Orders === '' && (
          <Grid stackable>
            <Grid.Row>
              <ChartData />
            </Grid.Row>
            <Grid.Row>
              <Outwardstable name="TagOrder" />
              {/* <OrdersTable  /> */}
            </Grid.Row>
          </Grid>
        )}
      {dashboardStore.dashboard.L1CardValue === 'Orders' &&
        dashboardStore.dashboard.L2CardValueOrders === '' &&
        dashboardStore.dashboard.valueForL3Orders === '' && (
          <Grid stackable>
            <Grid.Row>
              <ChartData />
            </Grid.Row>
            <Grid.Row>
              {
                store.commonStore.hfcCustomerChanges ? <DeliveryRequest/> :  <Outwardstable name="TagOrder" />
              }
            </Grid.Row>
          </Grid>
        )}
    </div>
  );
}

export default observer(DashboardShowGrid);
